import type { TFunction } from "i18next";
import type * as yup from "yup";

export function isEmailDomainOnBlocklist(email: string, blockedDomains: string[]): boolean {
  if (!blockedDomains.length) return false;
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const domain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  if (!domain) return false;

  return blockedDomains.some((blocked) => {
    const b = blocked.trim().toLowerCase();
    if (!b) return false;
    return domain === b || domain.endsWith(`.${b}`);
  });
}

export function applyCheckoutBlockedEmailDomainsToStringSchema(
  schema: yup.StringSchema,
  t: TFunction,
  checkoutBlockedEmailDomains: string[],
): yup.StringSchema {
  return schema.test("checkout-blocked-email-domains", t("VOUCHERS_DISTRIBUTION.ERRORS.USE_PRIVATE_EMAIL"), (value) => {
    if (!checkoutBlockedEmailDomains.length) return true;
    if (value === undefined || value === null || value === "") return true;
    return !isEmailDomainOnBlocklist(String(value), checkoutBlockedEmailDomains);
  });
}
